import { ref, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { mapActions, useStore } from "vuex";
import { useHttp } from './http'

export function usePages() {
    const $axios = useHttp();
    const page = ref({})
    const pages = ref({})
    let errors = ref('')

    const getPage = async (websiteId, pageId, noCache = false) => {
        if (!page.value || true !== noCache) {
            return $axios.get(`websites/${websiteId}/pages/${pageId}`).then(({ data }) => {              
                return page.value = data.data;
            }).catch((e) => { console.log(e) })
        } else {
            return page.value;
        }
    }

    const destroyPage = async (websiteId, pageId) => {
        return $axios.delete(`websites/${websiteId}/pages/${pageId}`).then(({ data }) => {
            return true;
        }).catch((e) => { console.log(e) })
    }

    const getPages = async (websiteId, noCache = false) => {
        if (true === noCache) {
            return $axios.get(`websites/${websiteId}/pages/`).then(({ data }) => {
                pages.value = data.data;
                return pages.value;
            }).catch((e) => {console.log(e)})
        } else {
            return pages.value;
        }
    }

    const getFirstPageOrCreate = async (websiteId) => {
        return $axios.get(`/websites/${websiteId}/pages`)
            .then((response) => {
                if (Object.prototype.toString.call(response.data.data) === "[object Array]"
                    && response.data.data.length > 0) {
                    page.value = response.data.data[0];
                } else {
                    page.value = storePage(websiteId, {})
                }
                return page.value;
            }).catch((error) => {
                console.log(error);
                return undefined;
            })
    }

    const storePage = async (websiteId, data) => {
        errors.value = ''
        const dummyData = {
            "name": "",
            "head": {},
            "style": {},
        }
        try {
            return await $axios.post(`/websites/${websiteId}/pages`, { ...dummyData, ...data })
                .then((response) => {
                    page.value = response.data?.data;
                    return page.value
                })
        } catch (e) {
            if (e.response.status === 422) {
                for (const key in e.response.data.errors) {
                    errors.value += e.response.data.errors[key][0] + ' ';
                }
            }
        }
    }

    const updatePage = async (websiteId, data) => {
        errors.value = ''
        try {
            return await $axios.put(`/websites/${websiteId}/pages/${data.id}`, { ...data })
                .then((response) => {
                    page.value = response.data?.data;
                    return page
                }).catch((response) => {
                    if (response.status === 422) {
                        for (const key in response.data.errors) {
                            errors.value += response.data.errors[key][0] + ' ';
                        }
                    }
                })
        } catch (e) {
            console.log(e);
        }
    }

    return {
        errors,
        page,
        pages,
        getPage,
        getPages,
        storePage,
        updatePage,
        destroyPage,
        getFirstPageOrCreate,
    }
}
